import { produce } from 'immer';
import { actionTypes } from './constants';
import { IJackpot, IJackpotState, TGetJackpotProps, TJackpots, TJackpotsAction } from './types';
import { reducer as coreReducer, defaultState } from 'js/components/common/Jackpot/store/reducer';
import { IJackpotState as IJackpotStateCore } from '@core/js/components/common/Jackpot/store/types';

const getJackpot = ({ amount, step, currencyCode, hitTime }: TGetJackpotProps): IJackpot => {
    const isZeroStep = !Number(step);

    return {
        currencyCode,
        step: Number(step) || 0.01,
        amount: isZeroStep ? amount * 0.99 : amount,
        isZeroStep,
        originAmount: amount,
        hitTime,
        updateTimer: null,
        moduleId: null
    };
};

export const reducer = produce((draftState, action: TJackpotsAction): IJackpotState | void => {
    switch (action.type) {
        case actionTypes.SET_JACKPOTS_EYECON_FETCH: {
            const { jackpots = [] } = action.payload;

            const casino = jackpots.reduce<TJackpots>((memo, { levels, gamecodes, currency }) => {
                const amount = levels.sort((a, b) => b.value - a.value)[0].valueCurrency;

                return {
                    ...memo,
                    ...gamecodes.reduce((acc, game) => ({
                        ...acc,
                        [game]: getJackpot({
                            amount,
                            step: 0.00001,
                            currencyCode: currency,
                            hitTime: null
                        })
                    }), {})
                };
            }, {});

            draftState.jackpots = {
                ...draftState.jackpots,
                ...casino
            };

            draftState.jackpotStartTime = Date.now();
            break;
        }
        case actionTypes.SET_JACKPOTS_GAMES_GLOBAL_FETCH: {
            draftState.jackpots = {
                ...draftState.jackpots,
                ...action.payload.jackpots.reduce<TJackpots>((acc, jackpot) => {
                    const jackpotCode = `${action.payload.prefix}${jackpot.moduleId}`;

                    if (!action.payload.gamePayId && acc[jackpotCode]?.amount > jackpot.startAtValue) {
                        return acc;
                    }

                    acc[`${jackpotCode}${action.payload.gamePayId ? `_${action.payload.gamePayId}` : ''}`] = {
                        moduleId: jackpot.moduleId,
                        currencyCode: jackpot.currencyIsoCode,
                        step: jackpot.centsPerSecond / 1000,
                        amount: jackpot.startAtValue,
                        originAmount: jackpot.endAtValue,
                        isZeroStep: true,
                        hitTime: null,
                        updateTimer: jackpot.numberOfSeconds
                    };

                    return acc;
                }, {})
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }
        default:
            return coreReducer.call(this, draftState as IJackpotStateCore, action) as IJackpotState;
    }
}, defaultState);
